import React from "react";
import { Route, Switch } from "react-router-dom";
import Appraisal from "components/Dashboard/Appraisal/Appraisal";
import AppraisalDetail from "components/Dashboard/Appraisal/AppraisalDetail";
import BookingInquiry from "components/Dashboard/BookingInquiry";
import Calendar from "components/Dashboard/Calendar";
import UserList from "components/Dashboard/User/UserList";
import UserCreate from "components/Dashboard/User/UserCreate";
import UserUpdate from "components/Dashboard/User/UserUpdate";
import Overview from "components/Dashboard/Overview/Overview";

import OfferingList from "components/Dashboard/InternalBidding/Offering";
import OfferingDetail from "components/Dashboard/InternalBidding/Offering/OfferingDetail";
import TNTList from "components/Dashboard/InternalBidding/TNT";
import NegotiationUpdate from "components/Dashboard/InternalBidding/TNT/NegotiationUpdate";
import DealConfirmation from "components/Dashboard/InternalBidding/DealConfirmation";
import DealConfirmationUpdate from "components/Dashboard/InternalBidding/DealConfirmation/DealConfirmationUpdate";
import HandoverList from "components/Dashboard/InternalBidding/Handover";
import HandoverUpdate from "components/Dashboard/InternalBidding/Handover/HandoverUpdate";
import DocumentList from "components/Dashboard/InternalBidding/DocumentApproval";
import DocumentApprovalUpdate from "components/Dashboard/InternalBidding/DocumentApproval/DocumentApprovalUpdate";
import FinanceList from "components/Dashboard/InternalBidding/Finance";
import FinanceUpdate from "components/Dashboard/InternalBidding/Finance/FinanceUpdate";
import FinalList from "components/Dashboard/InternalBidding/Final";
import FinalDetail from "components/Dashboard/InternalBidding/Final/FinalDetail";
import PDIList from "components/Dashboard/InternalBidding/PDI/PDI";
import PDIDetail from "components/Dashboard/InternalBidding/PDI/PDIDetail";

import TradeInProgress from "components/Dashboard/Approval/TradeIn/InProgress/TradeIn";
import TradeInRequest from "components/Dashboard/Approval/TradeIn/InProgress/TradeInRequest";
import TradeInProgressDetail from "components/Dashboard/Approval/TradeIn/InProgress/TradeInDetail";
import TradeInFinal from "components/Dashboard/Approval/TradeIn/Final/TradeIn";
import TradeInFinalDetail from "components/Dashboard/Approval/TradeIn/Final/TradeInDetail";
import NewCarInProgress from "components/Dashboard/Approval/NewCar/InProgress/NewCar";
import NewCarInRequest from "components/Dashboard/Approval/NewCar/InProgress/NewCarInRequest";
import NewCarInProgressDetail from "components/Dashboard/Approval/NewCar/InProgress/NewCarDetail";
import NewCarFinal from "components/Dashboard/Approval/NewCar/Final/NewCar";
import NewCarFinalDetail from "components/Dashboard/Approval/NewCar/Final/NewCarDetail";

import GrossProfit from "components/Dashboard/Update/GrossProfit/GrossProfit";
import OTR from "components/Dashboard/Update/OTR/OTR";

import PriceList from "components/Dashboard/PriceList/PriceList";
import BannerList from "components/Dashboard/BannerList/BannerList";

import CustomerList from "components/Dashboard/B2C/Customer/Customer";
import CustomerDetail from "../../components/Dashboard/B2C/Customer/CustomerDetail";

import CustomerCar from "components/Dashboard/B2C/CustomerCar/CustomerCar";
import CarBookingService from "components/Dashboard/B2C/CarBooking/CarBooking";

import CustomerCarDetail from "components/Dashboard/B2C/CustomerCar/CustomerCarDetail";
import CarBookingServiceDetail from "components/Dashboard/B2C/CarBooking/CarBookingDetail";

import PriceCheckHistory from "components/Dashboard/PriceCheckHistory/PriceCheckHistory";

import BranchList from "components/Dashboard/Branch/BranchList";
import BranchCreate from "components/Dashboard/Branch/BranchCreate";
import BranchUpdate from "components/Dashboard/Branch/BranchUpdate";

import PricingAreaList from "components/Dashboard/Area/PricingArea/PricingAreaList";
import PricingAreaCreate from "components/Dashboard/Area/PricingArea/PricingAreaCreate";
import PricingAreaUpdate from "components/Dashboard/Area/PricingArea/PricingAreaUpdate";

import NewCarAreaList from "components/Dashboard/Area/NewCarArea/NewCarAreaList";
import NewCarAreaCreate from "components/Dashboard/Area/NewCarArea/NewCarAreaCreate";
import NewCarAreaUpdate from "components/Dashboard/Area/NewCarArea/NewCarAreaUpdate";

import BusinessAreaList from "components/Dashboard/Area/BusinessArea/BusinessAreaList";
import BusinessAreaCreate from "components/Dashboard/Area/BusinessArea/BusinessAreaCreate";
import BusinessAreaUpdate from "components/Dashboard/Area/BusinessArea/BusinessAreaUpdate";

import BranchAreaList from "components/Dashboard/Area/BranchArea/BranchAreaList";
import BranchAreaCreate from "components/Dashboard/Area/BranchArea/BranchAreaCreate";
import BranchAreaUpdate from "components/Dashboard/Area/BranchArea/BranchAreaUpdate";

import MobbiPriceCheckHistory from "components/Dashboard/MobbiPriceCheckHistory/MobbiPriceCheckHistory";
import MobbiPriceList from "components/Dashboard/MobbiPriceList/PriceList";
import MobbiLog from "components/Dashboard/MobbiLog/MobbiLog";
import EApprovalList from "../../components/Dashboard/EApproval/EApprovalList";
import EApprovalCreate from "../../components/Dashboard/EApproval/EApprovalCreate";
import EApprovalEdit from "../../components/Dashboard/EApproval/EApprovalEdit";
import EApprovalDetail from "../../components/Dashboard/EApproval/EApprovalDetail";
import EApprovalBOHDetail from "../../components/Dashboard/EApproval/EApprovalBOHDetail";
import EApprovalGMDetail from "../../components/Dashboard/EApproval/EApprovalGMDetail";
import EApprovalAdminDetail from "../../components/Dashboard/EApproval/EApprovalAdminDetail";
import EApprovalSearchLicensePlate from "../../components/Dashboard/EApproval/EApprovalSearchLicensePlate";

import ConfigurationList from "components/Dashboard/Configuration/ConfigurationList";
import ConfigurationUpdate from "../../components/Dashboard/Configuration/ConfigurationUpdate";

export default () => {
  return (
    <Switch>
      {/* Dispatch Page */}
      <Route path="/home" exact component={BookingInquiry} />

      {/* Appraisal Page */}
      <Route path="/home/appraisal" exact component={Appraisal} />
      <Route path="/home/appraisal/:id" component={AppraisalDetail} />

      {/* Calendar Page */}
      <Route path="/home/calendar" component={Calendar} />

      {/* Bidding Page */}
      <Route
        path="/home/internal-bidding/offering"
        exact
        component={OfferingList}
      />
      <Route
        path="/home/internal-bidding/offering/:id"
        component={OfferingDetail}
      />
      <Route path="/home/internal-bidding/tnt" exact component={TNTList} />
      <Route
        path="/home/internal-bidding/tnt/:id"
        component={NegotiationUpdate}
      />
      <Route
        path="/home/internal-bidding/deal-confirmation"
        exact
        component={DealConfirmation}
      />
      <Route
        path="/home/internal-bidding/deal-confirmation/:id"
        component={DealConfirmationUpdate}
      />
      <Route
        path="/home/internal-bidding/handover"
        exact
        component={HandoverList}
      />
      <Route
        path="/home/internal-bidding/handover/:id"
        component={HandoverUpdate}
      />
      <Route
        path="/home/internal-bidding/document-approval"
        exact
        component={DocumentList}
      />
      <Route
        path="/home/internal-bidding/document-approval/:id"
        component={DocumentApprovalUpdate}
      />
      <Route
        path="/home/internal-bidding/finance"
        exact
        component={FinanceList}
      />
      <Route
        path="/home/internal-bidding/finance/:id"
        component={FinanceUpdate}
      />
      <Route path="/home/internal-bidding/final" exact component={FinalList} />
      <Route path="/home/internal-bidding/final/:id" component={FinalDetail} />
      <Route path="/home/internal-bidding/pdi" exact component={PDIList} />
      <Route path="/home/internal-bidding/pdi/:id" component={PDIDetail} />

      {/* User Page */}
      <Route path="/home/:role-user" exact component={UserList} />
      <Route path="/home/user/create" component={UserCreate} />
      <Route path="/home/user/:id/update" component={UserUpdate} />

      {/* OverView Page */}
      <Route path="/home/overview" component={Overview} />

      {/* Approval Page */}
      <Route
        path="/home/approval/trade-in-progress"
        exact
        component={TradeInProgress}
      />
      <Route
        path="/home/approval/trade-in-request-:status"
        exact
        component={TradeInRequest}
      />
      <Route
        path="/home/approval/trade-in-progress/:id"
        exact
        component={TradeInProgressDetail}
      />
      <Route
        path="/home/approval/trade-in-final-:status"
        exact
        component={TradeInFinal}
      />
      <Route
        path="/home/approval/trade-in-final/:id"
        exact
        component={TradeInFinalDetail}
      />
      <Route
        path="/home/approval/new-car-in-progress"
        exact
        component={NewCarInProgress}
      />
      <Route
        path="/home/approval/new-car-in-request-:status"
        exact
        component={NewCarInRequest}
      />
      <Route
        path="/home/approval/new-car-in-progress/:id"
        exact
        component={NewCarInProgressDetail}
      />
      <Route
        path="/home/approval/new-car-final-:status"
        exact
        component={NewCarFinal}
      />
      <Route
        path="/home/approval/new-car-final/:id"
        exact
        component={NewCarFinalDetail}
      />

      {/*E-Approval Page*/}
      <Route
        path="/home/e-approval/selling-system"
        exact
        component={EApprovalList}
      />
      <Route
        path="/home/e-approval/search-license-plate"
        exact
        component={EApprovalSearchLicensePlate}
      />
      <Route
        path="/home/e-approval/selling-system/boh"
        exact
        component={EApprovalList}
      />
      <Route
        path="/home/e-approval/selling-system/gm"
        exact
        component={EApprovalList}
      />
      <Route
        path="/home/e-approval/selling-system/create"
        exact
        component={EApprovalCreate}
      />
      <Route
        path="/home/e-approval/selling-system/update/:id"
        exact
        component={EApprovalEdit}
      />
      <Route
        path="/home/e-approval/selling-system/detail/:id"
        exact
        component={EApprovalDetail}
      />
      <Route
        path="/home/e-approval/selling-system/boh/detail/:id"
        exact
        component={EApprovalBOHDetail}
      />
      <Route
        path="/home/e-approval/selling-system/gm/detail/:id"
        exact
        component={EApprovalGMDetail}
      />

      <Route
        path="/home/e-approval/selling-system/admin/detail/:id"
        exact
        component={EApprovalAdminDetail}
      />

      {/* Update Page */}
      <Route path="/home/update/gross-profit" exact component={GrossProfit} />
      <Route path="/home/update/otr" exact component={OTR} />

      {/* Price List Page */}
      <Route path="/home/price-list/:area" exact component={PriceList} />

      {/* Price List Page */}
      <Route path="/home/banner/:app" exact component={BannerList} />

      {/* Customer*/}
      <Route path="/home/customer-list" exact component={CustomerList} />
      <Route path="/home/customer/:id" exact component={CustomerDetail} />

      {/* Customer Car List */}
      <Route path="/home/customer-car-list" exact component={CustomerCar} />
      <Route
        path="/home/customer-car/:id"
        exact
        component={CustomerCarDetail}
      />

      {/* Car Booking Service List */}
      <Route
        path="/home/car-booking-service-list"
        exact
        component={CarBookingService}
      />
      <Route
        path="/home/car-booking-service/:id"
        exact
        component={CarBookingServiceDetail}
      />

      {/* Price Check History List */}
      <Route
        path="/home/price-check-history-:role"
        exact
        component={PriceCheckHistory}
      />

      {/* Price Check History List */}
      <Route path="/home/branch" exact component={BranchList} />
      <Route path="/home/branch/create" exact component={BranchCreate} />
      <Route path="/home/branch/update/:id" exact component={BranchUpdate} />

      {/* Area Pricing*/}
      <Route path="/home/pricing-area" exact component={PricingAreaList} />
      <Route
        path="/home/pricing-area/:id/update"
        exact
        component={PricingAreaUpdate}
      />
      <Route
        path="/home/pricing-area/create"
        exact
        component={PricingAreaCreate}
      />

      {/* Area New Car*/}
      <Route path="/home/new-car-area" exact component={NewCarAreaList} />
      <Route
        path="/home/new-car-area/:id/update"
        exact
        component={NewCarAreaUpdate}
      />
      <Route
        path="/home/new-car-area/create"
        exact
        component={NewCarAreaCreate}
      />

      {/* Area Branch*/}
      <Route path="/home/branch-area" exact component={BranchAreaList} />
      <Route
        path="/home/branch-area/:id/update"
        exact
        component={BranchAreaUpdate}
      />
      <Route
        path="/home/branch-area/create"
        exact
        component={BranchAreaCreate}
      />

      {/* Area Business*/}
      <Route path="/home/business-area" exact component={BusinessAreaList} />
      <Route
        path="/home/business-area/:id/update"
        exact
        component={BusinessAreaUpdate}
      />
      <Route
        path="/home/business-area/create"
        exact
        component={BusinessAreaCreate}
      />

      {/* Mobbi Price Check History List */}
      <Route
        path="/home/mobbi-price-check-history-:role"
        exact
        component={MobbiPriceCheckHistory}
      />

      {/* Mobbi Price List Page */}
      <Route
        path="/home/mobbi-price-list/:area"
        exact
        component={MobbiPriceList}
      />

      {/* Mobbi Price List Page */}
      <Route path="/home/mobbi/logs" exact component={MobbiLog} />

      <Route path="/home/configurations" exact component={ConfigurationList} />
      <Route
        path="/home/configurations/:id/update"
        exact
        component={ConfigurationUpdate}
      />
    </Switch>
  );
};



// WEBPACK FOOTER //
// src/containers/Dashboard/routes.js